var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-datetime-picker',_vm._g(_vm._b({attrs:{"label":_vm.label,"disabled":_vm.disabled,"no-title":"","locale":"pt-BR","dateFormat":"dd/MM/yyyy","timeFormat":_vm.hasSeconds ? 'HH:mm:ss' : 'HH:mm',"clearText":_vm.$t('new-event.buttons.clear'),"okText":_vm.$t('new-event.buttons.confirm'),"color":_vm.$config.dados.corinputs,"theme":"light","background-color":"primary","timePickerProps":{
    showSeconds: false,
    format: '24hr',
    amPm: false,
    color: _vm.$config.dados.corinputs,
  },"datePickerProps":{
    multiple: _vm.range,
    firstDayOfWeek: 1,
    format: 'dd/MM/yyyy',
    locale: _vm.locale,
    color: _vm.$config.dados.corinputs,
    allowedDates: _vm.allowedDatesFunction,
  },"textFieldProps":_vm.simpleStyle
      ? {
          placeholder: _vm.placeholder || _vm.$t('new-event.datepicket-placeholder'),
          hideDetails: _vm.hideDetails || 'auto',
          solo: false,
          persistentPlaceholder: true,
          dense: true,
          class: 'mt-2',
        }
      : {
          class: 'rounded-lg',
          hideDetails: _vm.hideDetails || 'auto',
          solo: false,
          outlined: true,
          dense: true,
          appendIcon: 'mdi-calendar-clock-outline',
          color: 'tertiary',
          persistentPlaceholder: true,
          placeholder: _vm.placeholder || _vm.$t('new-event.datepicket-placeholder'),
          rules: _vm.rules,
        }},on:{"input":_vm.updateFormattedDateTime},scopedSlots:_vm._u([{key:"dateIcon",fn:function(){return [_c('v-icon',{attrs:{"color":"tertiary"}},[_vm._v("mdi-calendar-range")])]},proxy:true},{key:"timeIcon",fn:function(){return [_c('v-icon',{attrs:{"color":"tertiary"}},[_vm._v("mdi-clock-time-eight-outline")])]},proxy:true}]),model:{value:(_vm.dateTime),callback:function ($$v) {_vm.dateTime=$$v},expression:"dateTime"}},'v-datetime-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }